export class Contact {
  firstName: string;
  lastName: string;
  emailAddress: string;
  subject: string;
  message: string;
  to:string;
  constructor(contact?) {
    if (contact) {
      this.firstName = contact.firstName;
      this.lastName = contact.lastName;
      this.emailAddress = contact.emailAddress;
      this.subject = contact.subject;
      this.message = contact.message;
      this.to = contact.to;
    }
  }
}
